import { render, staticRenderFns } from "./MessageForm.vue?vue&type=template&id=fe2cb8a2&scoped=true&"
import script from "./MessageForm.vue?vue&type=script&lang=js&"
export * from "./MessageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2cb8a2",
  null
  
)

export default component.exports